import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('benefits_sets_export_publishing',
  'benefits_sets_export_publishings',
  'publish')
const reducer = generator.generate()

export default reducer
